import React, { Fragment } from 'react';
import css from 'styled-jsx/css';

import Header from './common/Header';
import SupportForm from './common/elements/SupportForm';
import SubscribeForm from './subscribe/SubscribeForm';
import Footer from './common/Footer';

const headerStyle = css.resolve`
  .header {
    position: relative;
    z-index: 200;
  }
`;

const Subscribe = ({
  countries,
  prices,
  apiKey,
  affiliateId,
  profile,
  quote
}) => {
  return (
    <Fragment>
      <Header className={headerStyle.className} profile={profile} />
      <SubscribeForm
        countries={countries}
        prices={prices}
        apiKey={apiKey}
        affiliateId={affiliateId}
        quote={quote}
      />
      <SupportForm fixedButtonDisabled />
      <Footer />
      {headerStyle.styles}
    </Fragment>
  );
};

export default Subscribe;
